"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transferFunds = exports.sendTwoFactorAuthCodeForTransfers = exports.requestTransfers = exports.requestTransferSucceeded = exports.requestTransferFunds = exports.receiveTransfers = exports.receiveIncomingTransfers = exports.getTransfers = exports.getIncomingTransfers = exports.TRANSFER_REQUEST_SUCCEEDED = exports.GET_TRANSFERS_REQUESTED = exports.GET_TRANSFERS_RECEIVED = exports.GET_INCOMING_TRANSFERS = void 0;
var _apex = _interopRequireDefault(require("../../apex"));
var _apiActions = require("./apiActions");
var _snackbarActions = require("./snackbarActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _modalActions = require("./modalActions");
var _sidePaneActions = require("./sidePaneActions");
var _selectors = require("../margin/selectors");
var _actions = require("../margin/actions");
var _snackbarHelper = require("../../helpers/snackbarHelper");
var _actions2 = require("../futures/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var GET_TRANSFERS_REQUESTED = exports.GET_TRANSFERS_REQUESTED = 'GET_TRANSFERS_REQUESTED';
var GET_TRANSFERS_RECEIVED = exports.GET_TRANSFERS_RECEIVED = 'GET_TRANSFERS_RECEIVED';
var GET_INCOMING_TRANSFERS = exports.GET_INCOMING_TRANSFERS = 'GET_INCOMING_TRANSFERS';
var TRANSFER_REQUEST_SUCCEEDED = exports.TRANSFER_REQUEST_SUCCEEDED = 'TRANSFER_REQUEST_SUCCEEDED';
var getTransfers = exports.getTransfers = function getTransfers(AccountId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var OMSId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatch(requestTransfers());
            OMSId = getState().user.userInfo.OMSId;
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetTransfers', {
              OMSId: OMSId,
              AccountId: AccountId
            })).then(function (res) {
              if (Array.isArray(res)) {
                return dispatch(receiveTransfers(res));
              }
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getTransfers',
                text: (0, _snackbarHelper.parseServerErrorMessage)('GetTransfers', res),
                type: 'warning'
              }));
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getIncomingTransfers = exports.getIncomingTransfers = function getIncomingTransfers(OMSId, AccountId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetTransfersReceived', {
              OMSId: OMSId,
              AccountId: AccountId
            })).then(function (res) {
              if (Array.isArray(res)) {
                return dispatch(receiveIncomingTransfers(res));
              }
              dispatch(receiveIncomingTransfers([]));
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getTransfersReceived',
                text: (0, _snackbarHelper.parseServerErrorMessage)('GetTransfersReceived', res),
                type: 'warning'
              }));
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var requestTransferFunds = exports.requestTransferFunds = function requestTransferFunds(payload) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var OMSId, selectedAccountId, response, snackbarPayload;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            selectedAccountId = getState().user.selectedAccountId;
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('RequestTransferFunds', _objectSpread({
              OMSId: OMSId,
              ReceiverAccountId: selectedAccountId
            }, payload)));
          case 1:
            response = _context3.v;
            snackbarPayload = response.result ? {
              id: 'requestTransferSuccess',
              // t('Request transfer succeeded');
              text: 'Request transfer succeeded',
              type: 'success'
            } : {
              id: 'requestTransferError',
              text: (0, _errorTextFormatter.formatErrorText)(response),
              type: 'warning'
            };
            dispatch((0, _snackbarActions.showSnack)(snackbarPayload));
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var transferFunds = exports.transferFunds = function transferFunds(values, pane) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var _getState$user, SenderAccountId, OMSId, accounts, payload, senderAccount, receiverAccount, marginAccountId, marginInfoSuccess, _getState$margin, marginAccountInfo, response, state, _accounts, _senderAccount, _receiverAccount, isFuturesReceiver, Amount, ProductSymbol, successText, parsedDetail, snackbarPayload;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _getState$user = getState().user, SenderAccountId = _getState$user.selectedAccountId, OMSId = _getState$user.userInfo.OMSId, accounts = _getState$user.accounts;
            payload = _objectSpread({
              OMSId: OMSId,
              SenderAccountId: SenderAccountId
            }, values); // Check if sender or receiver account is a margin account with ClosedWithLoss status
            senderAccount = accounts.find(function (a) {
              return a.AccountId === SenderAccountId;
            });
            receiverAccount = accounts.find(function (a) {
              return a.AccountId === values.ReceiverAccountId;
            });
            if (!((senderAccount === null || senderAccount === void 0 ? void 0 : senderAccount.AccountType) === 'Margin' || (receiverAccount === null || receiverAccount === void 0 ? void 0 : receiverAccount.AccountType) === 'Margin')) {
              _context4.n = 2;
              break;
            }
            marginAccountId = (senderAccount === null || senderAccount === void 0 ? void 0 : senderAccount.AccountType) === 'Margin' ? SenderAccountId : values.ReceiverAccountId;
            _context4.n = 1;
            return dispatch((0, _actions.getMarginAccountInfo)(marginAccountId, OMSId));
          case 1:
            marginInfoSuccess = _context4.v;
            if (!marginInfoSuccess) {
              _context4.n = 2;
              break;
            }
            marginAccountInfo = (_getState$margin = getState().margin) === null || _getState$margin === void 0 ? void 0 : _getState$margin.accountInfo;
            if (!((marginAccountInfo === null || marginAccountInfo === void 0 ? void 0 : marginAccountInfo.MarginAccountStatus) === 'ClosedWithLoss')) {
              _context4.n = 2;
              break;
            }
            dispatch((0, _snackbarActions.showSnack)({
              id: 'transferBlockedClosedWithLoss',
              // t('Transfer Failed: Your account status currently prevents funds transfers. Please review your account or Margin history for details, or contact support if needed.')
              text: 'Transfer Failed: Your account status currently prevents funds transfers. Please review your account or Margin history for details, or contact support if needed.',
              type: 'warning'
            }));
            if (pane) {
              dispatch((0, _sidePaneActions.closeSidePane)(pane));
            }
            return _context4.a(2);
          case 2:
            _context4.n = 3;
            return dispatch((0, _apiActions.callAPI)('TransferFunds', payload));
          case 3:
            response = _context4.v;
            if (response.result) {
              dispatch(requestTransferSucceeded(values));
              state = getState();
              _accounts = (0, _selectors.accountsSelector)(state);
              _senderAccount = _accounts.find(function (a) {
                return a.AccountId === payload.SenderAccountId;
              });
              _receiverAccount = _accounts.find(function (a) {
                return a.AccountId === payload.ReceiverAccountId;
              });
              if ((_senderAccount === null || _senderAccount === void 0 ? void 0 : _senderAccount.AccountType) === 'Margin' || (_receiverAccount === null || _receiverAccount === void 0 ? void 0 : _receiverAccount.AccountType) === 'Margin') {
                dispatch((0, _actions.getMarginAccountInfo)((_senderAccount === null || _senderAccount === void 0 ? void 0 : _senderAccount.AccountType) === 'Margin' ? _senderAccount.AccountId : _receiverAccount.AccountId, OMSId));
              }
              if ((_senderAccount === null || _senderAccount === void 0 ? void 0 : _senderAccount.AccountType) === 'Futures' || (_receiverAccount === null || _receiverAccount === void 0 ? void 0 : _receiverAccount.AccountType) === 'Futures') {
                dispatch((0, _actions2.getAccountFuturesBalances)((_senderAccount === null || _senderAccount === void 0 ? void 0 : _senderAccount.AccountType) === 'Futures' ? _senderAccount.AccountId : _receiverAccount.AccountId));
              }
            }
            isFuturesReceiver = accounts.some(function (account) {
              return account.AccountId === values.ReceiverAccountId && account.AccountType === 'Futures';
            });
            Amount = values.Amount, ProductSymbol = values.ProductSymbol;
            successText = 'Transfer succeeded';
            parsedDetail = {};
            if (response.detail && typeof response.detail === 'string') {
              try {
                parsedDetail = JSON.parse(response.detail);
              } catch (e) {
                parsedDetail = {};
              }
            }
            if (response.result && isFuturesReceiver && Amount && ProductSymbol) {
              if (parsedDetail.Notes === 'funded_on_hold') {
                successText = "You have successfully transferred ".concat(Amount, " ").concat(ProductSymbol, " to your futures account. Funds will be available shortly after processing.");
              } else {
                successText = "You have successfully transferred ".concat(Amount, " ").concat(ProductSymbol, " to your futures account.");
              }
            } else if (Amount && ProductSymbol) {
              successText = "You have successfully transferred ".concat(Amount, " ").concat(ProductSymbol);
            }
            snackbarPayload = response.result ? {
              id: 'transferSuccess',
              text: successText,
              type: 'success'
            } : {
              id: 'transferError',
              text: isFuturesReceiver ? 'There was an error transferring funds to your futures account. Please try again' : (0, _errorTextFormatter.formatErrorText)(response),
              type: 'warning'
            };
            if (pane) {
              dispatch((0, _sidePaneActions.closeSidePane)(pane));
            }
            dispatch((0, _snackbarActions.showSnack)(snackbarPayload));
          case 4:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var receiveIncomingTransfers = exports.receiveIncomingTransfers = function receiveIncomingTransfers(payload) {
  return {
    type: GET_INCOMING_TRANSFERS,
    payload: payload
  };
};
var receiveTransfers = exports.receiveTransfers = function receiveTransfers(payload) {
  return {
    type: GET_TRANSFERS_RECEIVED,
    payload: payload
  };
};
var requestTransfers = exports.requestTransfers = function requestTransfers() {
  return {
    type: GET_TRANSFERS_REQUESTED
  };
};
var requestTransferSucceeded = exports.requestTransferSucceeded = function requestTransferSucceeded(payload) {
  return {
    type: TRANSFER_REQUEST_SUCCEEDED,
    payload: payload
  };
};
var sendTwoFactorAuthCodeForTransfers = exports.sendTwoFactorAuthCodeForTransfers = function sendTwoFactorAuthCodeForTransfers(code) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch) {
      var auth;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return _apex["default"].connection.Authenticate2FA({
              Code: code
            });
          case 1:
            auth = _context5.v;
            if (auth.Authenticated) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2, auth);
          case 2:
            dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.SEND_REQUEST_2FA));
            dispatch((0, _sidePaneActions.closeSidePane)());
            dispatch((0, _snackbarActions.showSnack)({
              id: 'transferSuccess',
              // t('Transfer succeeded');
              text: 'Transfer succeeded',
              type: 'success'
            }));
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x8) {
      return _ref5.apply(this, arguments);
    };
  }();
};